import { render, staticRenderFns } from "./salon.vue?vue&type=template&id=307c8c58&scoped=true"
import script from "./salon.vue?vue&type=script&lang=js"
export * from "./salon.vue?vue&type=script&lang=js"
import style0 from "./salon.vue?vue&type=style&index=0&id=307c8c58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307c8c58",
  null
  
)

export default component.exports